module.exports = __webpack_public_path__ + "img/logo_slim.e0e17dc9.svg";